import { getRole } from '../blocs/roomInfo'
import queryClient from '../../queryClient'

import {
  type ApiResponse,
  HTTPMethod,
  isErrorWithApiCause,
  performRequest,
} from './legacyApi'

type WorkspaceTokenDTO = {
  bearer_token: string // '97b58371-420b-2e36-79fa-65f2da7f55be:apibearer'
  expiration_time: string // '2024-10-02T11:55:12.30681+00:00'
  user_id: number // 77322418
  canonical_user_p: string // true
  site_name: string // "Theis' Playground"
  site_id: number // 77322413
  site_url: string // 'https://theis.twentythree.com'
  domain: string // 'theis.twentythree.com'
  display_name: string // "Theis' Playground"
  internal_site_name: string // "Theis' Playground"
  trunc_site_name: string // "Theis' Playground"
  product_key: string // 'tube'
  product_name: string // 'TwentyThree Enterprise'
  site_key: string // 'theisplayground'
  subscription_id: number // 77322408
  api_base_url: string // 'https://theis.twentythree.com/'
  logo_url: string // 'https://theis.twentythree.com/files/r285/sitelogo.png'
  icon_url: string // 'https://theis.twentythree.com/files/r285/sitelogo.png'
  entry_url: string // '/theisplayground/manage/videos'
  capabilities: string // 'upload-video create-live-event has-live create-webinar has-webinars create-webinar-series has-social has-analytics has-video-section has-video-player has-optimize has-spots has-video-management has-audience has-audience-tracking'
  starred_p: boolean // true
}

const getWorkspaceToken = () => {
  return queryClient.fetchQuery(
    ['tokens'],
    async () => {
      if (getRole() !== 'producer') return undefined

      const { data } = (await performRequest({
        url: '/api/2/user/tokens',
        method: HTTPMethod.GET,
      })) as ApiResponse<WorkspaceTokenDTO[]>

      const workspaceTokenInfo = data.find(
        (t) => t.domain === window.location.hostname
      )

      if (!workspaceTokenInfo) {
        throw new Error('Could not find authentication token for this domain')
      }

      return workspaceTokenInfo?.bearer_token
    },
    {
      staleTime: 4.5 * 60e3,
      cacheTime: 4.5 * 60e3,
      retry: (count, error) => {
        if (
          (isErrorWithApiCause(error) &&
            error.message.startsWith(
              "You don't have the necessary permissions"
            )) ||
          count > 2
        ) {
          if (getRole() === 'producer') {
            const locationReturn = `return_url=${window.location.href}`
            window.location.href = `/login?${locationReturn}`
          }
          return false
        }
        return true
      },
    }
  )
}

export { getWorkspaceToken }
